// extracted by mini-css-extract-plugin
export default {"results":"ThingEventsGrid_results__q9+fH"};